import { createApiActionTypes } from '../../helpers/actions';

export const TARA_GET_SURVEY = createApiActionTypes('TARA_GET_SURVEY');
export const TARA_POST_SURVEY = createApiActionTypes('TARA_POST_SURVEY');

export const TARA_SET_HAS_MADE_INTRODUCTION = 'TARA_SET_HAS_MADE_INTRODUCTION';
export const TARA_SET_HAS_CURATED_TICKETS = 'TARA_SET_HAS_CURATED_TICKETS';
export const TARA_SET_IS_VIEWING_SURVEY = 'TARA_SET_IS_VIEWING_SURVEY';
export const TARA_SET_SURVEY_COMPLETED = 'TARA_SET_SURVEY_COMPLETED';



// WEBPACK FOOTER //
// ./src/actions/tara/types.js